import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchNotifications } from '../../actions/fetch-notifications';
import { readNotification } from '../../actions/read-notification';
import { pageOpened } from '../../actions/page-opened';
import { buttonClicked } from '../../actions/button-clicked';
import AnimatedLoader from '../../components/animated-loader';
import Page from '../../components/page';
import Button from '../../components/button';
import EmptyStates from '../../components/empty-states';
import NotificationList from '../../components/notification-list';
import Link from '../../components/link/internal-link';
import AppLoaded from '../../components/app-loaded';
import withTranslate from '../../hoc/with-translate';
import { getNotifications } from '../../selectors/notification-selectors';
import { getIsNotificationsLoaded } from '../../selectors/is-loaded-selectors';
import { getIsNotificationsLoading } from '../../selectors/is-loading-selectors';
import { getSecondaryColorNumbers } from '../../services/get-colors';
import { NOTIFICATIONS } from '../../services/detect-route';
import styles from './notifications-page.scss';
import listItemStyles from '../../components/notification-list-item/notification-list-item.scss';

const renderStyles = () => `
  .${listItemStyles.container}:hover {
    background-color: rgba(${getSecondaryColorNumbers()}, 0.1);
  }
`;

export class NotificationsPage extends Component {
  static fetchData = ({ store }) => {
    return store.dispatch(fetchNotifications());
  };

  constructor(props) {
    super(props);

    this.handleNotificationClick = this.handleNotificationClick.bind(this);
  }

  componentDidMount() {
    this.props.fetchNotifications();
    this.props.pageOpened({ page: NOTIFICATIONS });
  }

  handleNotificationClick({ _id, isRead }) {
    this.props.buttonClicked({ name: 'notification', _id });
    if (!isRead) {
      this.props.readNotification(_id);
    }
  }

  render() {
    const { notifications, t, isLoading, isLoaded } = this.props;
    return (
      <Page className={styles.container} noSpacing>
        <style>
          {renderStyles()}
        </style>
        <AnimatedLoader isLoading={isLoading && !isLoaded}>
          {notifications.length ?
            <NotificationList notifications={notifications} onItemClick={this.handleNotificationClick}/> :
            <EmptyStates
              className={styles.notifications}
              title={t('notifications-page.no-notifications-title')}
              content={t('notifications-page.no-notifications-content')}
            >
              <Button component={Link} to="/">
                {t('notifications-page.back-to-forum')}
              </Button>
            </EmptyStates>}
        </AnimatedLoader>
        <AppLoaded/>
      </Page>
    );
  }
}

NotificationsPage.propTypes = {
  fetchNotifications: PropTypes.func.isRequired,
  readNotification: PropTypes.func.isRequired,
  pageOpened: PropTypes.func.isRequired,
  notifications: PropTypes.array.isRequired,
  buttonClicked: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isLoaded: PropTypes.bool.isRequired,
  t: PropTypes.func,
};

const mapStateToProps = state => ({
  notifications: getNotifications(state),
  isLoading: getIsNotificationsLoading(state),
  isLoaded: getIsNotificationsLoaded(state),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    fetchNotifications,
    readNotification,
    pageOpened,
    buttonClicked,
  }, dispatch);

export default flowRight(
  connect(mapStateToProps, mapDispatchToProps),
  withTranslate,
)(NotificationsPage);



// WEBPACK FOOTER //
// ./app/containers/notifications-page/notifications-page.js